// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/group_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Empty } from "../../../google/protobuf/empty.js";
import { Chat } from "./chat_types.js";
import { GroupChangeEvent } from "./group_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface SetDisplayNameRequest {
  chatGuid: string;
  displayName: string;
  clientMessageId?: string | undefined;
}

export interface SetDisplayNameResponse {
  chat: Chat | undefined;
}

/**
 * Adds one or more participants. An empty `addresses` list
 * is rejected with `INVALID_ARGUMENT`.
 */
export interface AddParticipantsRequest {
  chatGuid: string;
  addresses: string[];
  clientMessageId?: string | undefined;
}

export interface AddParticipantsResponse {
  chat: Chat | undefined;
}

/**
 * Removes one or more participants. An empty `addresses`
 * list is rejected with `INVALID_ARGUMENT`.
 */
export interface RemoveParticipantsRequest {
  chatGuid: string;
  addresses: string[];
  clientMessageId?: string | undefined;
}

export interface RemoveParticipantsResponse {
  chat: Chat | undefined;
}

export interface LeaveGroupRequest {
  chatGuid: string;
  clientMessageId?: string | undefined;
}

export interface SetIconRequest {
  chatGuid: string;
  /** Server infers MIME type and file extension from `data`. */
  data: Uint8Array;
  clientMessageId?: string | undefined;
}

export interface RemoveIconRequest {
  chatGuid: string;
  clientMessageId?: string | undefined;
}

export interface GetIconRequest {
  chatGuid: string;
}

export interface GetIconResponse {
  data: Uint8Array;
  /**
   * MIME type of `data`. Always set on success; a missing icon returns
   * `NOT_FOUND` instead of an empty payload.
   */
  mimeType: string;
}

export interface SubscribeGroupEventsRequest {
  /** Absent = subscribe to every group chat the caller can observe. */
  chatGuid?: string | undefined;
}

export interface SubscribeGroupEventsResponse {
  /**
   * Monotonic global sequence shared with `EventService.CatchUpEvents`
   * and every other `Subscribe*` stream. Absent on heartbeat frames.
   */
  sequence?: number | undefined;
  groupChanged?: GroupChangeEvent | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseSetDisplayNameRequest(): SetDisplayNameRequest {
  return { chatGuid: "", displayName: "", clientMessageId: undefined };
}

export const SetDisplayNameRequest: MessageFns<SetDisplayNameRequest> = {
  encode(message: SetDisplayNameRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetDisplayNameRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDisplayNameRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDisplayNameRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SetDisplayNameRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SetDisplayNameRequest>): SetDisplayNameRequest {
    return SetDisplayNameRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetDisplayNameRequest>): SetDisplayNameRequest {
    const message = createBaseSetDisplayNameRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.displayName = object.displayName ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSetDisplayNameResponse(): SetDisplayNameResponse {
  return { chat: undefined };
}

export const SetDisplayNameResponse: MessageFns<SetDisplayNameResponse> = {
  encode(message: SetDisplayNameResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetDisplayNameResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDisplayNameResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDisplayNameResponse {
    return { chat: isSet(object.chat) ? Chat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: SetDisplayNameResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = Chat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<SetDisplayNameResponse>): SetDisplayNameResponse {
    return SetDisplayNameResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetDisplayNameResponse>): SetDisplayNameResponse {
    const message = createBaseSetDisplayNameResponse();
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    return message;
  },
};

function createBaseAddParticipantsRequest(): AddParticipantsRequest {
  return { chatGuid: "", addresses: [], clientMessageId: undefined };
}

export const AddParticipantsRequest: MessageFns<AddParticipantsRequest> = {
  encode(message: AddParticipantsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    for (const v of message.addresses) {
      writer.uint32(18).string(v!);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddParticipantsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddParticipantsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.addresses.push(reader.string());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddParticipantsRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => globalThis.String(e))
        : [],
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: AddParticipantsRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.addresses?.length) {
      obj.addresses = message.addresses;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<AddParticipantsRequest>): AddParticipantsRequest {
    return AddParticipantsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddParticipantsRequest>): AddParticipantsRequest {
    const message = createBaseAddParticipantsRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.addresses = object.addresses?.map((e) => e) || [];
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseAddParticipantsResponse(): AddParticipantsResponse {
  return { chat: undefined };
}

export const AddParticipantsResponse: MessageFns<AddParticipantsResponse> = {
  encode(message: AddParticipantsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddParticipantsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddParticipantsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddParticipantsResponse {
    return { chat: isSet(object.chat) ? Chat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: AddParticipantsResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = Chat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<AddParticipantsResponse>): AddParticipantsResponse {
    return AddParticipantsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddParticipantsResponse>): AddParticipantsResponse {
    const message = createBaseAddParticipantsResponse();
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    return message;
  },
};

function createBaseRemoveParticipantsRequest(): RemoveParticipantsRequest {
  return { chatGuid: "", addresses: [], clientMessageId: undefined };
}

export const RemoveParticipantsRequest: MessageFns<RemoveParticipantsRequest> = {
  encode(message: RemoveParticipantsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    for (const v of message.addresses) {
      writer.uint32(18).string(v!);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveParticipantsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveParticipantsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.addresses.push(reader.string());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveParticipantsRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => globalThis.String(e))
        : [],
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: RemoveParticipantsRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.addresses?.length) {
      obj.addresses = message.addresses;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveParticipantsRequest>): RemoveParticipantsRequest {
    return RemoveParticipantsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveParticipantsRequest>): RemoveParticipantsRequest {
    const message = createBaseRemoveParticipantsRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.addresses = object.addresses?.map((e) => e) || [];
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseRemoveParticipantsResponse(): RemoveParticipantsResponse {
  return { chat: undefined };
}

export const RemoveParticipantsResponse: MessageFns<RemoveParticipantsResponse> = {
  encode(message: RemoveParticipantsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveParticipantsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveParticipantsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveParticipantsResponse {
    return { chat: isSet(object.chat) ? Chat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: RemoveParticipantsResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = Chat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveParticipantsResponse>): RemoveParticipantsResponse {
    return RemoveParticipantsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveParticipantsResponse>): RemoveParticipantsResponse {
    const message = createBaseRemoveParticipantsResponse();
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    return message;
  },
};

function createBaseLeaveGroupRequest(): LeaveGroupRequest {
  return { chatGuid: "", clientMessageId: undefined };
}

export const LeaveGroupRequest: MessageFns<LeaveGroupRequest> = {
  encode(message: LeaveGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LeaveGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLeaveGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LeaveGroupRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: LeaveGroupRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<LeaveGroupRequest>): LeaveGroupRequest {
    return LeaveGroupRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LeaveGroupRequest>): LeaveGroupRequest {
    const message = createBaseLeaveGroupRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSetIconRequest(): SetIconRequest {
  return { chatGuid: "", data: new Uint8Array(0), clientMessageId: undefined };
}

export const SetIconRequest: MessageFns<SetIconRequest> = {
  encode(message: SetIconRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetIconRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetIconRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetIconRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SetIconRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SetIconRequest>): SetIconRequest {
    return SetIconRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetIconRequest>): SetIconRequest {
    const message = createBaseSetIconRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.data = object.data ?? new Uint8Array(0);
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseRemoveIconRequest(): RemoveIconRequest {
  return { chatGuid: "", clientMessageId: undefined };
}

export const RemoveIconRequest: MessageFns<RemoveIconRequest> = {
  encode(message: RemoveIconRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveIconRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveIconRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveIconRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: RemoveIconRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveIconRequest>): RemoveIconRequest {
    return RemoveIconRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveIconRequest>): RemoveIconRequest {
    const message = createBaseRemoveIconRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseGetIconRequest(): GetIconRequest {
  return { chatGuid: "" };
}

export const GetIconRequest: MessageFns<GetIconRequest> = {
  encode(message: GetIconRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIconRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIconRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIconRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: GetIconRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetIconRequest>): GetIconRequest {
    return GetIconRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIconRequest>): GetIconRequest {
    const message = createBaseGetIconRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseGetIconResponse(): GetIconResponse {
  return { data: new Uint8Array(0), mimeType: "" };
}

export const GetIconResponse: MessageFns<GetIconResponse> = {
  encode(message: GetIconResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.mimeType !== "") {
      writer.uint32(18).string(message.mimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIconResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIconResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIconResponse {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
    };
  },

  toJSON(message: GetIconResponse): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    return obj;
  },

  create(base?: DeepPartial<GetIconResponse>): GetIconResponse {
    return GetIconResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIconResponse>): GetIconResponse {
    const message = createBaseGetIconResponse();
    message.data = object.data ?? new Uint8Array(0);
    message.mimeType = object.mimeType ?? "";
    return message;
  },
};

function createBaseSubscribeGroupEventsRequest(): SubscribeGroupEventsRequest {
  return { chatGuid: undefined };
}

export const SubscribeGroupEventsRequest: MessageFns<SubscribeGroupEventsRequest> = {
  encode(message: SubscribeGroupEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== undefined) {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeGroupEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeGroupEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeGroupEventsRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : undefined,
    };
  },

  toJSON(message: SubscribeGroupEventsRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== undefined) {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeGroupEventsRequest>): SubscribeGroupEventsRequest {
    return SubscribeGroupEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeGroupEventsRequest>): SubscribeGroupEventsRequest {
    const message = createBaseSubscribeGroupEventsRequest();
    message.chatGuid = object.chatGuid ?? undefined;
    return message;
  },
};

function createBaseSubscribeGroupEventsResponse(): SubscribeGroupEventsResponse {
  return { sequence: undefined, groupChanged: undefined, heartbeat: undefined };
}

export const SubscribeGroupEventsResponse: MessageFns<SubscribeGroupEventsResponse> = {
  encode(message: SubscribeGroupEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sequence !== undefined) {
      writer.uint32(8).uint64(message.sequence);
    }
    if (message.groupChanged !== undefined) {
      GroupChangeEvent.encode(message.groupChanged, writer.uint32(82).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeGroupEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeGroupEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.groupChanged = GroupChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeGroupEventsResponse {
    return {
      sequence: isSet(object.sequence) ? globalThis.Number(object.sequence) : undefined,
      groupChanged: isSet(object.groupChanged)
        ? GroupChangeEvent.fromJSON(object.groupChanged)
        : isSet(object.group_changed)
        ? GroupChangeEvent.fromJSON(object.group_changed)
        : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: SubscribeGroupEventsResponse): unknown {
    const obj: any = {};
    if (message.sequence !== undefined) {
      obj.sequence = Math.round(message.sequence);
    }
    if (message.groupChanged !== undefined) {
      obj.groupChanged = GroupChangeEvent.toJSON(message.groupChanged);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeGroupEventsResponse>): SubscribeGroupEventsResponse {
    return SubscribeGroupEventsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeGroupEventsResponse>): SubscribeGroupEventsResponse {
    const message = createBaseSubscribeGroupEventsResponse();
    message.sequence = object.sequence ?? undefined;
    message.groupChanged = (object.groupChanged !== undefined && object.groupChanged !== null)
      ? GroupChangeEvent.fromPartial(object.groupChanged)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/** Group-chat administration plus a durable event stream. */
export type GroupServiceDefinition = typeof GroupServiceDefinition;
export const GroupServiceDefinition = {
  name: "GroupService",
  fullName: "photon.imessage.v1.GroupService",
  methods: {
    /** Writes */
    setDisplayName: {
      name: "SetDisplayName",
      requestType: SetDisplayNameRequest as typeof SetDisplayNameRequest,
      requestStream: false,
      responseType: SetDisplayNameResponse as typeof SetDisplayNameResponse,
      responseStream: false,
      options: {},
    },
    addParticipants: {
      name: "AddParticipants",
      requestType: AddParticipantsRequest as typeof AddParticipantsRequest,
      requestStream: false,
      responseType: AddParticipantsResponse as typeof AddParticipantsResponse,
      responseStream: false,
      options: {},
    },
    removeParticipants: {
      name: "RemoveParticipants",
      requestType: RemoveParticipantsRequest as typeof RemoveParticipantsRequest,
      requestStream: false,
      responseType: RemoveParticipantsResponse as typeof RemoveParticipantsResponse,
      responseStream: false,
      options: {},
    },
    /**
     * Local user voluntarily leaves the group. The chat ceases to be
     * visible from this device, hence no Chat snapshot.
     */
    leaveGroup: {
      name: "LeaveGroup",
      requestType: LeaveGroupRequest as typeof LeaveGroupRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    setIcon: {
      name: "SetIcon",
      requestType: SetIconRequest as typeof SetIconRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    removeIcon: {
      name: "RemoveIcon",
      requestType: RemoveIconRequest as typeof RemoveIconRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    /** Reads */
    getIcon: {
      name: "GetIcon",
      requestType: GetIconRequest as typeof GetIconRequest,
      requestStream: false,
      responseType: GetIconResponse as typeof GetIconResponse,
      responseStream: false,
      options: {},
    },
    /** Streams */
    subscribeGroupEvents: {
      name: "SubscribeGroupEvents",
      requestType: SubscribeGroupEventsRequest as typeof SubscribeGroupEventsRequest,
      requestStream: false,
      responseType: SubscribeGroupEventsResponse as typeof SubscribeGroupEventsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface GroupServiceImplementation<CallContextExt = {}> {
  /** Writes */
  setDisplayName(
    request: SetDisplayNameRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<SetDisplayNameResponse>>;
  addParticipants(
    request: AddParticipantsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<AddParticipantsResponse>>;
  removeParticipants(
    request: RemoveParticipantsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<RemoveParticipantsResponse>>;
  /**
   * Local user voluntarily leaves the group. The chat ceases to be
   * visible from this device, hence no Chat snapshot.
   */
  leaveGroup(request: LeaveGroupRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  setIcon(request: SetIconRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  removeIcon(request: RemoveIconRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  /** Reads */
  getIcon(request: GetIconRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetIconResponse>>;
  /** Streams */
  subscribeGroupEvents(
    request: SubscribeGroupEventsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<SubscribeGroupEventsResponse>>;
}

export interface GroupServiceClient<CallOptionsExt = {}> {
  /** Writes */
  setDisplayName(
    request: DeepPartial<SetDisplayNameRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<SetDisplayNameResponse>;
  addParticipants(
    request: DeepPartial<AddParticipantsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<AddParticipantsResponse>;
  removeParticipants(
    request: DeepPartial<RemoveParticipantsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<RemoveParticipantsResponse>;
  /**
   * Local user voluntarily leaves the group. The chat ceases to be
   * visible from this device, hence no Chat snapshot.
   */
  leaveGroup(request: DeepPartial<LeaveGroupRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  setIcon(request: DeepPartial<SetIconRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  removeIcon(request: DeepPartial<RemoveIconRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  /** Reads */
  getIcon(request: DeepPartial<GetIconRequest>, options?: CallOptions & CallOptionsExt): Promise<GetIconResponse>;
  /** Streams */
  subscribeGroupEvents(
    request: DeepPartial<SubscribeGroupEventsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<SubscribeGroupEventsResponse>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
